import { UseBaseQueryOptions } from '@/core/api/type'
import { TransactionQueryKeys } from '@/modules/transaction/keys'
import { GetDepositTransactionsByIdResponse } from '@/modules/transaction/types'
import BankTransactionService from '../../services'

export const queryDepositTransactionsByIdOptions = (
	id: string,
	options?: UseBaseQueryOptions<GetDepositTransactionsByIdResponse>,
) => ({
	queryKey: [TransactionQueryKeys.DEPOSIT_TRANSACTION_BY_ID, id],
	queryFn: () => BankTransactionService.getDepositTransactionsById(id),
	...options,
})
